import { createRoot } from 'react-dom/client';
import { App } from './App';
import { AuthGate } from './SignIn';
import './styles.css';

createRoot(document.getElementById('root')!).render(<AuthGate>{(me, signOut) => <App me={me} signOut={signOut} />}</AuthGate>);
